export default {
  books: 'مدیر کتاب ها',
  comments: 'مدیر دیدگاه ها',
  contacts: 'مدیر تماس ها',
  giftCardTypes: 'مدیر انواع کارت هدیه',
  giftCards: 'مدیر کارت هدیه',
  menus: 'مدیر فهرست ها',
  pages: 'مدیر برگه ها',
  root: 'مدیر ارشد',
  sections: 'مدیر بخش های کتاب',
  settings: 'مدیر تنظیمات',
  users: 'مدیر کاربران',
  widgetAreas: 'مدیر ابزارک ها',
  selectAtLeastOnePermissionForThisRole: 'حداقل یک مجوز برای این نقش انتخاب شود'
}
